import { getViewCapabilities } from 'components/spreadsheet/constants/viewCapabilities'
import { ISpreadsheetData } from '../types'

type ImportContext = Pick<ISpreadsheetData, 'isAdmin' | 'isContributor'> & {
  tableDetails: Pick<ISpreadsheetData['tableDetails'], 'isDeleted' | 'isSynced'>
  viewDetails: Pick<ISpreadsheetData['viewDetails'], 'type' | 'disableNewRow' | 'disableSyncCsv'>
}

// Whether Import Data is offered on this view: always to admins, and to contributors on a table that
// isn't synced and a view that lets them add rows and import CSVs. The import button and the View
// actions menu both ask this, so neither offers an import the other wouldn't.
export const canImportData = ({ isAdmin, isContributor, tableDetails, viewDetails }: ImportContext): boolean =>
  !tableDetails.isDeleted &&
  getViewCapabilities(viewDetails.type).toolbar.importData &&
  (isAdmin || (!tableDetails.isSynced && !viewDetails.disableNewRow && !viewDetails.disableSyncCsv && isContributor))
